import React from "react";

const ToggleButton = ({
  togglekey = 0,
  onClick = "",
  toggle = false,
  setToggle = () => {},
}) => {
  return (
    <div onClick={onClick}>
      <div className="custom-control custom-switch">
        <input
          type="checkbox"
          className="custom-control-input"
          id={togglekey}
          checked={toggle}
          onClick={() => setToggle(!toggle)}
          readOnly
        />
        <label className="custom-control-label" htmlFor={togglekey}></label>
      </div>
    </div>
  );
};

export default ToggleButton;
